import {
  ADD_CLIENT,
  GET_CLIENTS,
  GET_CLIENT,
  CLIENTS_LOADING,
  DELETE_CLIENT,
  GET_DELETED_CLIENTS,
  GET_CLIENT_BY_COMPID,
  GET_CLIENTS_BY_VENDOR
} from '../actions/types';

const initialState = {
  clientsByVendor: [],
  clients: [],
  deletedclients: [],
  client: {},
  loading: false
};

export default function FuncState(state = initialState, action) {
  switch (action.type) {
    case CLIENTS_LOADING:
      return {
        ...state,
        loading: true
      };
    case GET_CLIENTS:
      return {
        ...state,
        clients: action.payload,
        loading: false
      };
    case GET_CLIENT:
      return {
        ...state,
        client: action.payload,
        loading: false
      };
    case GET_CLIENT_BY_COMPID:
      return {
        ...state,
        clients: action.payload,
        loading: false
      };
    case GET_CLIENTS_BY_VENDOR:
      return {
        ...state,
        clientsByVendor: action.payload,
        loading: false
      };
    case ADD_CLIENT:
      return {
        ...state,
        clients: [action.payload, ...state.clients]
      };
    case DELETE_CLIENT:
      return {
        ...state,
        clients: state.clients.filter(client => client._id !== action.payload)
      };
    case GET_DELETED_CLIENTS:
      return {
        ...state,
        deletedclients: action.payload,
        loading: false
      };
    default:
      return state;
  }
}
